module.exports = __webpack_public_path__ + "img/randabstand-DIN4141.f41edc2a.png";